import React from 'react';
import { Box, Button, Card, Grid, Stack, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { Recommendation } from '../mockStats';

interface RecommendationStripProps {
  items: Recommendation[];
}

const RecommendationStrip: React.FC<RecommendationStripProps> = ({ items }) => (
  <Card>
    <Stack spacing={2}>
      <Stack direction={'row'} alignItems={'center'} spacing={1}>
        <AutoAwesomeIcon sx={{ color: 'primary.main' }} />
        <Typography variant={'h3'}>{'Що зробити далі'}</Typography>
      </Stack>

      <Grid container spacing={2}>
        {items.map((it) => (
          <Grid key={it.id} size={{ xs: 12, md: 4 }}>
            <Box
              sx={(theme) => ({
                borderRadius: 2,
                border: `1px solid ${
                  theme.palette.mode === 'dark'
                    ? '#303A48'
                    : theme.palette.primary.tableBorder
                }`,
                height: '100%',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
              })}
            >
              <Typography fontWeight={700}>{it.title}</Typography>
              <Typography
                color={'text.secondary'}
                variant={'body2'}
                sx={{ mt: 0.75, flex: 1 }}
              >
                {it.hint}
              </Typography>
              <Button
                component={Link}
                to={it.to}
                endIcon={<ArrowForwardIcon />}
                variant={'text'}
                sx={{ alignSelf: 'flex-start', mt: 1.5, px: 0 }}
              >
                {it.cta}
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Stack>
  </Card>
);

export default RecommendationStrip;
